import React from 'react';

/**
 * A placeholder for the "Cookie Preferences" link that allows the user to
 * edit their cookie preferences
 */
const CookiePreferencesLink = () => {
    // This span will be filled in by the script in Consent.jsx.
    // This ID must be "cookie_preferences" for the contents of the
    // span to render.
    return <span id="cookie_preferences" />;
};

export default CookiePreferencesLink;
